import React, { useEffect, FC, useState } from "react";
import { Table, Button, Input, Tooltip, Checkbox } from "antd";
import { YHModal } from "@/components/YHModal";
import { ColumnsType } from "antd/lib/table";
import { YhBox } from "@/components/YhBox";
import { useMaintenanceDetailsModel, IMaterialDetailModel } from "./maintenanceDetailsModels";
import { RouterParamType } from "@/model/navModel";
import { YhBut } from "@/components/YhButton";
import { formatIntPoint, repairFormatNum, formatNum, formatIntPoint1 } from "@/utils/utils";
import { components } from "@/components/YHEditTable/editTable";
import useGlobalModel from "@/model/globalModel";
import { ISalesTypeEnum, IPriceTypeEnum, IServiceNatureCodeType } from "@/types/ScmEnums";
import { purchaseDetailsService } from "@/views/stock/purchaseDetails/purchaseDetailsService";
import { maintenanceService } from '../../maintenanceService'
import { roleColumnModel } from "@/utils/roleColumn";
import YhTootip from "@/components/YhTootip";
enum OPT_TYPE {
    ADD = 1,
    REMOVE = 2
}
export const MaterialModal: FC<RouterParamType> = ({ id, mode }) => {
    const { shopAndOrg: { shopId }, user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();
    const {
        SBcode,
        materialModel: visible,
        setMaterialModel,
        detailAddForm,
        detailEditForm,
        searchWorkMaterialData,
        workMaterialDataSource,
        addDataMaterialSource,
        initPgCfg,
        workMaterialPgCfg,
        isThreeService,
        workMaterialloadData,
        resetWorkMaterialloadData,
        setSearchWorkMaterialData,
        setAddDataMaterialSource,
        setWorkMaterialDataSource,
        transformsToPoMaterialDetailList,
        detailMaterialAddList,
        detailMaterialEditList
    } = useMaintenanceDetailsModel();
    const [checked, setChecked] = useState(true);
    const [minPrice, setMinPrice] = useState('')
    const [maxPrice, setMaxPrice] = useState('')
    const [isHovered, setIsHovered] = useState(false);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);

    const onOk = () => {
        transformsToPoMaterialDetailList(mode)
        onCancel()
    }
    const onCancel = () => {
        setMaterialModel(false);
        setAddDataMaterialSource([]);
        setSearchWorkMaterialData({})
        setChecked(true)

    };
    useEffect(() => {
        if (visible) {
            workMaterialloadData(initPgCfg, { age: 1 }, mode)
        }
    }, [visible])

    const column = (optype: number) => [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '商品编号',
            width: 120,
            dataIndex: 'materialCode',
            render: (text: any, record: IMaterialDetailModel) => <YhTootip text={text} onClick={() => { handleMouseOver(record) }} />,
            //render: (text: any,record:IMaterialDetailModel) => <YhTootip text={text} onMouseOver={()=>{handleMouseOver(record)}}  onMouseLeave={()=>{handleMouseLeave()}}/>,
        }, {
            title: '配件名称',
            width: 140,
            dataIndex: 'materialName',
            render: (text: any, record: IMaterialDetailModel) => <YhTootip text={text} onClick={() => { handleMouseOver(record) }} />,
        },
        {
            title: '规格型号',
            width: 120,
            dataIndex: 'model',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '适用车型',
            width: 120,
            dataIndex: 'vehicleModel',
            render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,
        }, {
            title: '品牌',
            width: 100,
            dataIndex: 'brandName',
        }, {
            title: '单位',
            width: 60,
            dataIndex: 'unitName',
        }, {
            title: '可用库存',
            width: 100,
            dataIndex: 'availableStock',
        }, {
            title: '库房',
            width: 140,
            dataIndex: 'warehouseName',
        },
        {
            title: '使用数量',
            width: 100,
            dataIndex: 'num',
            editable: true,
        },
        ...((str) => {
            if (str) {
                return [{
                    title: '价格',
                    width: 100,
                    dataIndex: 'price',
                    editable: true,

                },
                {
                    title: '总计',
                    width: 100,
                    dataIndex: 'amount',

                }
                ]
            } else {
                return []
            }
        })(optype !== OPT_TYPE.ADD),
        {
            title: '货位',
            width: 100,
            dataIndex: 'shelfCode',
        }, {
            title: '采购单号',
            width: 180,
            dataIndex: 'purchaseCode',
        }, {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            render: (text: any, record: any) => optype === OPT_TYPE.ADD ? (
                <YhBut
                    type="add"
                    txt="添加"
                    click={() => {
                        add(record)
                    }}
                    disabled={
                        !!addDataMaterialSource.find(item => item.id === record.id) ||
                        !!(mode === 'add' ? detailMaterialAddList : detailMaterialEditList).filter(item => item.status !== 'details.preparation.ware.out').find(item => item.materialCode === record.materialCode && item.purchaseCode === record.purchaseCode) ||
                        record.availableStock === 0
                    }
                />
            ) : (
                <YhBut
                    type="delete"
                    txt="删除"
                    click={() => remove(record)}
                />
            )
        }
    ];

    const newSelectColumns = (optType: number) =>
        column(optType).map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IMaterialDetailModel, rowIndex: number) => ({
                    colIndex: index,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: optType === OPT_TYPE.ADD ? notHandleSave : handleSave,
                }),
            }
        })

    const roleColumns = (optType: number) => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "order", "roleCodes": roles };
        return getRoleColumns("order", "新增商品", newSelectColumns(optType), params);
    };

    // latestPurPrice：采购进货价
    // lateSalePrice：最近销售价
    // purchasePrice：档案进价
    // retailPrice：配件档案销售价
    //维修类型为保养合约 或者 索赔服务 ?取采购进货价 否则取 配件明细的价格根据售价选择来决定 
    const add = async (record: IMaterialDetailModel) => {
        let { priceTypeCode, serviceNatureCode, customerCode } = mode === "add" ? detailAddForm : detailEditForm;
        let { latestPurPriceNew, latestPurPrice, materialCode, lateSalePrice, purchasePrice, petroleumPrice, retailPrice, num, price, ...params } = record as { latestPurPriceNew: number, latestPurPrice: number, lateSalePrice: number, petroleumPrice: number, purchasePrice: number, retailPrice: number, num: number, materialCode: string, price: number }
        let newPrice: number = !!latestPurPrice ? latestPurPrice : purchasePrice;
        if (!(serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CLAIM || serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CLAIM_J || serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_MAINTAIN)) {
            switch (priceTypeCode) {
                //售价选择 客户最近销价 (需要通过接口查询，客户最近一次的销售价)
                case IPriceTypeEnum.CUSTOMER_LATEST:
                    let { retData: { price: recentPrice } } = await purchaseDetailsService.recentSalesPrice(shopId, materialCode, customerCode as string);
                    newPrice = +recentPrice;
                    break;
                //售价选择 最近销价 
                case IPriceTypeEnum.RECENT:
                    newPrice = lateSalePrice ?? retailPrice;
                    break;
                //售价选择 零售价
                case IPriceTypeEnum.RETAIL:
                    newPrice = retailPrice > price ? retailPrice : price;
                    break;
                //最新采购价
                case IPriceTypeEnum.LATEST_PURCHASE:
                    newPrice = latestPurPriceNew > price ? latestPurPriceNew : price;
                    break;
                //售价选择 采购成本价
                case IPriceTypeEnum.PUR_COST:
                    newPrice = latestPurPrice ?? purchasePrice;
                    break;
                //售价选择 档案进价
                case IPriceTypeEnum.BUYING_PRICE:
                    newPrice = purchasePrice ?? latestPurPrice;
                    break;
                //售价选择 石油价格
                case IPriceTypeEnum.PETROLEUM:
                    newPrice = petroleumPrice ?? purchasePrice
                    break;
            }
        }
        setAddDataMaterialSource(origin => [...origin, {
            ...record,
            num,
            price: newPrice,
            latestPurPrice: record.price,
            threeGuaranteesId: isThreeService ? SBcode : undefined,
            amount: +formatNum(num * newPrice),
        }])
    }
    const remove = async (record: IMaterialDetailModel) => {
        const filterAddDataSource = addDataMaterialSource.filter(item => item.id !== record.id)
        setAddDataMaterialSource(filterAddDataSource)
    }
    const notHandleSave = (row: IMaterialDetailModel) => {
        let { num, price, availableStock, purchasePrice, latestPurPrice } = row;
        // let newPurPrice = latestPurPrice !== 0 ? latestPurPrice : purchasePrice
        // lateSalePrice = +formatIntPoint1(lateSalePrice, newPurPrice, `修改价格不应小于进货价${newPurPrice}`);
        num = +formatIntPoint(num, availableStock, "选择数量>=可用库存数量");
        price = +formatNum(price);

        let newRow = {
            ...row,
            num,
            amount: +repairFormatNum(num * price)
        }
        const index = workMaterialDataSource.findIndex((item) => row.id === item.id);
        const item = workMaterialDataSource[index];
        workMaterialDataSource.splice(index, 1, { ...item, ...newRow });
        setWorkMaterialDataSource([...workMaterialDataSource])
    }
    const handleSave = (row: IMaterialDetailModel) => {
        let { num, price, availableStock, purchasePrice, latestPurPrice } = row;
        let newPurPrice = latestPurPrice !== 0 ? latestPurPrice : 0
        price = +formatIntPoint1(price, newPurPrice, `修改价格不应小于进货价${newPurPrice}`);
        num = +formatIntPoint(num, availableStock, "选择数量>=可用库存数量");
        let newRow = {
            ...row,
            num,
            price,
            amount: +repairFormatNum(num * price)
        }
        const index = addDataMaterialSource.findIndex((item) => row.id === item.id);
        const item = addDataMaterialSource[index];
        addDataMaterialSource.splice(index, 1, { ...item, ...newRow });
        setAddDataMaterialSource([...addDataMaterialSource])
    }

    const handleMouseOver = (record: IMaterialDetailModel) => {
        setIsHovered(true);
        let { customerCode } = mode === "add" ? detailAddForm : detailEditForm;
        let { materialCode, } = record as { materialCode: string }
        let data = {
            customerCode,
            shopId,
            materialCode
        }
        maintenanceService.price(data).then(res => {
            let { retData } = res
            let max = (retData as any).maxPrice.toFixed(2)
            let min = (retData as any).minPrice.toFixed(2)
            setMaxPrice(max)
            setMinPrice(min)
        })
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const rightChildren = <div className="flex">
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkMaterialData.materialCode}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkMaterialData({ ...searchWorkMaterialData, materialCode: e.target.value }) }}
            onBlur={(e) => { setSearchWorkMaterialData({ ...searchWorkMaterialData, materialCode: e.target.value?.trim() }) }}
            onPressEnter={() => workMaterialloadData(initPgCfg)}
            placeholder="商品编码"
        />
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkMaterialData.materialName}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkMaterialData({ ...searchWorkMaterialData, materialName: e.target.value }) }}
            onPressEnter={() => workMaterialloadData(initPgCfg)}
            placeholder="商品名称"
        />
        <Checkbox checked={checked} onChange={(e) => { setChecked(e.target.checked); workMaterialloadData(initPgCfg, { ...searchWorkMaterialData, age: e.target.checked ? 1 : 0 }); setSearchWorkMaterialData({ ...searchWorkMaterialData, age: e.target.checked ? 1 : 0 }) }}>
            是否有库存
        </Checkbox>
        <Button onClick={() => workMaterialloadData()} style={{ margin: "0px 5px 0px 10px" }} shape="round">检索</Button>
        <Button onClick={() => { resetWorkMaterialloadData(); setChecked(false) }} shape="round">重置</Button>
    </div>

    return <YHModal
        visible={visible}
        onOk={onOk}
        onCancel={onCancel}
        title="工单管理-选择配件"
        width={'70%'}
        bodyHeight={730}
        showFooter={true}
    >
        <YhBox title="待选配件列表" rightChildren={rightChildren} style={{ marginBottom: "5px" }}>
            <Table
                bordered
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.id as string}
                columns={roleColumns(OPT_TYPE.ADD) as ColumnsType<IMaterialDetailModel>}
                dataSource={workMaterialDataSource}
                pagination={{
                    ...workMaterialPgCfg,
                    position: ["bottomCenter"],
                    onChange: (pageNum, pageSize) => {
                        workMaterialloadData({ pageNum, pageSize }).then();
                    }
                }}
                components={components}
                onRow={record => {
                    return {
                        onClick: event => {
                            if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                                setSelectedRowKeys([]);
                            } else {
                                setSelectedRowKeys([record.key]);
                            }
                            let { customerCode } = mode === "add" ? detailAddForm : detailEditForm;
                            let { materialCode, } = record as { materialCode: string }
                            let data = {
                                customerCode,
                                shopId,
                                materialCode
                            }
                            maintenanceService.price(data).then(res => {
                                let { retData } = res
                                let max = (retData as any).maxPrice.toFixed(2)
                                let min = (retData as any).minPrice.toFixed(2)
                                setMaxPrice(max)
                                setMinPrice(min)
                            })

                        },

                    };
                }}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
        <YhBox title="已选配件列表">
            <Table
                bordered
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.id as string}
                columns={roleColumns(OPT_TYPE.REMOVE) as ColumnsType<IMaterialDetailModel>}
                dataSource={addDataMaterialSource}
                pagination={false}
                components={components}
                scroll={{ x: 'max-content', y: 200 }}
            />
            <div style={{ paddingRight: '50px', display: 'inline-block' }}><span style={{ fontSize: '18px', fontWeight: "bold", color: '#323232' }}>最高售价:</span><span style={{ fontSize: '18px', color: 'red', fontWeight: "bold" }}>{maxPrice}</span></div>
            <div style={{ display: 'inline-block' }}><span style={{ fontSize: '18px', fontWeight: "bold", color: '#323232' }}>最低售价:</span><span style={{ fontSize: '18px', color: 'red', fontWeight: "bold" }}>{minPrice}</span></div>
        </YhBox>
    </YHModal>
}